module.exports = __webpack_public_path__ + "img/cc-jcb.3d3efcb6.svg";